"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducers = void 0;
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.symbol.description.js");
var _paulCorePackage = require("paul-core-package");
var types = _interopRequireWildcard(require("./types"));
var _constants = require("../utils/constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const initialState = {
  errors: [],
  data: {
    buildings: [],
    allBuildings: [],
    activeBuilding: null,
    activePwhC: null,
    allPwhCByHtgSys: {},
    // {[id]: component, ...}
    activeStructure: {
      HtgSys: {},
      HtgSub: {},
      HtgHx: {},
      HtgCc: {},
      PwhSupply: {},
      PwcPoe: {},
      PwhC: {},
      PwcPipe: {}
    },
    components: {},
    // {HtgSys: [ component, ... ], ...} -
    devices: {
      byId: {},
      // {[id]: device, ...}
      byPwhC: [] // [d_id, ...]
    }
  },

  flushing: {
    stepById: {},
    // {[id]: {step: number, process: string}, ...}
    activeDeviceId: null,
    last: null,
    byId: {} // {[id]: flushing_params, ...}
  },

  infoModal: {
    open: false
  },
  filteredIdList: []
};
const reducers = exports.reducers = function reducers() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let {
    type,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  const {
    payload: listenPayload = null,
    result: listenResult = null
  } = payload || {};
  switch (type) {
    case types.SET_INITIAL_DEVICE_DATA:
    case _paulCorePackage.listenerTypes.GET_DEVICES_LISTENER:
      {
        var _listenResult$devices, _listenResult$devices2, _listenResult$devices3;
        const BuildingIdList = _paulCorePackage.functions.getBuildingIdList({
          structure: listenResult.structure
        });
        const defActiveBuildingId = BuildingIdList && BuildingIdList[0] ? BuildingIdList[0][0] || null : null;
        const structure = _paulCorePackage.functions.getCurrentStructure({
          structure: listenResult.structure,
          buildingId: defActiveBuildingId
        });
        const defActivePwhC = Object.keys(structure.active.PwhC)[0] || null;
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, {
            activeBuilding: defActiveBuildingId,
            activePwhC: defActivePwhC,
            activeStructure: structure.active,
            allPwhCByHtgSys: structure.byHtgSys.PwhC,
            components: listenResult.structure,
            allBuildings: listenResult.allBuildings,
            buildings: listenResult.buildings,
            devices: {
              byId: ((_listenResult$devices = listenResult.devices) === null || _listenResult$devices === void 0 ? void 0 : _listenResult$devices.byId) || initialState.data.devices.byId,
              byPwhC: ((_listenResult$devices2 = listenResult.devices) === null || _listenResult$devices2 === void 0 ? void 0 : _listenResult$devices2.byPwhC) || initialState.data.devices.byPwhC
            },
            equipmentNames: listenResult.equipmentNames
          }),
          filteredIdList: (_listenResult$devices3 = listenResult.devices) === null || _listenResult$devices3 === void 0 ? void 0 : _listenResult$devices3.byPwhC
        });
      }
    case _paulCorePackage.listenerTypes.GET_VALUES_LISTENER:
      {
        var _listenResult$devices4, _listenResult$devices5;
        if (_paulCorePackage.functions.isEmpty(listenPayload)) return state;
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, {
            devices: _objectSpread(_objectSpread({}, state.data.devices), {}, {
              byId: (_listenResult$devices4 = listenResult.devices) === null || _listenResult$devices4 === void 0 ? void 0 : _listenResult$devices4.byId
            })
          }),
          filteredIdList: (_listenResult$devices5 = listenResult.devices) === null || _listenResult$devices5 === void 0 ? void 0 : _listenResult$devices5.byPwhC
        });
      }
    case _paulCorePackage.listenerTypes.GET_VALUE_LISTENER:
      {
        const device = state.data.devices.byId[listenPayload.thingPDIDDevice];
        if (!device) return state;
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, {
            devices: _objectSpread(_objectSpread({}, state.data.devices), {}, {
              byId: listenResult.devices.byId
            })
          })
        });
      }
    case types.SET_ACTIVE_BUILDING:
      {
        const structure = _paulCorePackage.functions.getCurrentStructure({
          structure: state.data.components,
          buildingId: payload
        });
        // console.log('activeBuilding', structure)
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, {
            activeBuilding: payload,
            activePwhC: Object.keys(structure.active.PwhC)[0] || null,
            activeStructure: structure.active,
            allPwhCByHtgSys: structure.byHtgSys.PwhC,
            devices: _objectSpread(_objectSpread({}, state.data.devices), {}, {
              byPwhC: Object.values(structure.active).reduce((acc, g) => [...acc, ...(Object.values(g) || []).reduce((accC, c) => [...accC, ...c.devicesId], [])], [])
            })
          })
        });
      }
    case types.SET_ACTIVE_PWH_C:
      const structure = _paulCorePackage.functions.getCurrentStructure({
        structure: state.data.components,
        buildingId: state.data.activeBuilding,
        activePwhC: payload
      });
      // console.log('activePwhC', structure)
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          activePwhC: payload,
          activeStructure: structure.active,
          allPwhCByHtgSys: structure.byHtgSys.PwhC,
          devices: _objectSpread(_objectSpread({}, state.data.devices), {}, {
            byPwhC: Object.values(structure.active).reduce((acc, g) => [...acc, ...(Object.values(g) || []).reduce((accC, c) => [...accC, ...c.devicesId], [])], [])
          })
        })
      });
    case types.SET_INFO_MODAL:
      return _objectSpread(_objectSpread({}, state), {}, {
        infoModal: payload
      });
    case types.SET_FLUSHING_PARAMS:
      const byId = _objectSpread(_objectSpread({}, state.flushing.byId), {}, {
        [payload.thingPDIDDevice]: _objectSpread(_objectSpread({}, state.flushing.byId[payload.thingPDIDDevice] || {}), payload)
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        flushing: _objectSpread(_objectSpread({}, state.flushing), {}, {
          last: Object.values(byId).sort((a, b) => (b === null || b === void 0 ? void 0 : b.timestamp) - (a === null || a === void 0 ? void 0 : a.timestamp))[0] || null,
          byId
        })
      });
    case types.SET_ACTIVE_DEVICE_ID:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          flushing: _objectSpread(_objectSpread({}, state.flushing), {}, {
            activeDeviceId: payload
          })
        });
      }
    case types.SET_FLUSHING_STEP:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          flushing: _objectSpread(_objectSpread({}, state.flushing), {}, {
            stepById: _objectSpread(_objectSpread({}, state.flushing.stepById), {}, {
              [payload.thingPDIDDevice]: {
                step: payload.step,
                process: payload.process || null
              }
            })
          })
        });
      }
    case types.SET_FLUSHING_DURATION_SUCCEEDED:
      {
        const {
          requestData
        } = payload;
        return _objectSpread(_objectSpread({}, state), {}, {
          flushing: _objectSpread(_objectSpread({}, state.flushing), {}, {
            stepById: _objectSpread(_objectSpread({}, state.flushing.stepById), {}, {
              [requestData.thingPDIDDevice]: {
                step: 1,
                process: _constants.flushProcess.open
              }
            })
          })
        });
      }
    case types.SET_FILTERED_ID_LIST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          filteredIdList: payload
        });
      }
    case types.SET_FLUSHING_DURATION_FAILED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          errors: [...state.errors, _objectSpread({
            method: 'setDeviceCommand'
          }, payload)]
        });
      }
    case types.RESET_ALL:
      return initialState;
    default:
      return state;
  }
};